import React from "react";
import "./Transferts.css"; // Ajoutez ce fichier pour des styles personnalisés

// Importation explicite des images depuis /src/assets/images
import luxuryChauffeurService from "../../assets/images/luxury-chauffeur-service.jpg";
import familyFriendlyTransfers from "../../assets/images/family-freindly-transferts.jpg";
import corporateTravelSolutions from "../../assets/images/corporate-travel-solutions.jpg";
import vipAirportAssistance from "../../assets/images/vip-airport-assistance.jpg";

const Transfert = () => {
  const transferts = [
    {
      title: "Luxury Chauffeur Service",
      description:
        "Experience the elegance of our premium vehicles driven by professional chauffeurs for a serene journey.",
      image: luxuryChauffeurService,
    },
    {
      title: "Family-Friendly Transfers",
      description:
        "Enjoy spacious and comfortable rides with amenities tailored for families and young travelers.",
      image: familyFriendlyTransfers,
    },
    {
      title: "Corporate Travel Solutions",
      description:
        "Reliable and discreet transportation services designed to meet the needs of business professionals.",
      image: corporateTravelSolutions,
    },
    {
      title: "VIP Airport Assistance",
      description:
        "Personalized meet-and-greet service ensuring a seamless airport experience from arrival to departure.",
      image: vipAirportAssistance,
    },
  ];

  return (
    /*
    <section id="airport-rides" className="container-fluid py-5">
        <h2 className="mb-4 text-dark text-center">Seamless Airport Rides in Paris</h2>
      <div className="row align-items-center">    
    */
    <section id="transfert" className="container-fluid py-5">
        <h2 className="mb-4 text-dark text-center">Efficient Transfers, Stress-Free Journeys</h2>
        <div className="row px-0 px-sm-0 align-items-center">
          {transferts.map((transfert, index) => (
            <div className="col-md-6 px-0 px-lg-2 mb-4" key={index}>
              <div className="card border-0 shadow-sm">
                <img
                  src={transfert.image}
                  alt={transfert.title}
                  className="card-img-top"
                />
                <div className="card-body card-overlay w-75 rounded-top-4">
                  <h3 className="card-title">{transfert.title}</h3>
                  <p className="card-text">{transfert.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
    </section>
  );
};

export default Transfert;
